import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginPage from '../Login/LoginPage';
import LandingPage from '../LandingPage';
import LandingScreen from '../LandingPage/landingScreen';
import QuestionAnswer from '../QNA';
import DocSummerization from '../DocSum';
import DocSum2 from '../DocSum/DocSum2';

function RouterPage() {
  return (
    <div>
    <BrowserRouter>
    <Routes>
        <Route path="/" element={<LoginPage />}></Route>
        <Route path="/Home" element={<LandingScreen />}></Route>
        <Route path="/Home/DocX" element={<LandingPage />}></Route>
        {/* <Route path="/Home/DocSum" element={<DocSummerization />}></Route> */}
        <Route path="/Home/DocSum" element={<DocSum2 />}></Route>
        <Route path="/Home/Q&A" element={<QuestionAnswer />}></Route>
    </Routes>
    </BrowserRouter>
    </div>
  )
}

export default RouterPage;
